import { gql } from '@apollo/client'

export const GET_CUSTOM_STEPS = gql`
  query GetCustomSteps(
    $filters: CustomStepFiltersInput
    $pageInfo: PageInfoInput
  ) {
    customSteps(filters: $filters, pageInfo: $pageInfo) {
      items {
        customStepId
        label
        status
        createdAt
        updatedAt
        templateSteps {
          jobListingTemplateStepId
        }
      }
      totalCount
      pageInfo {
        limit
        offset
      }
    }
  }
`

export const CREATE_CUSTOM_STEP = gql`
  mutation CreateCustomStep($input: CreateCustomStepInput!) {
    createCustomStep(input: $input) {
      customStepId
      label
      status
    }
  }
`

export const UPDATE_CUSTOM_STEP = gql`
  mutation UpdateCustomStep($id: String!, $input: UpdateCustomStepInput!) {
    updateCustomStep(id: $id, input: $input) {
      customStepId
      label
      status
    }
  }
`

export const DELETE_CUSTOM_STEP = gql`
  mutation DeleteCustomStep($id: String!) {
    deleteCustomStep(id: $id) {
      customStepId
      status
    }
  }
`
